import type { UiLocale } from "@lib/locale";

export const DEFAULT_COURSE_SLUG = "portuguese-from-english";
export const DEFAULT_TARGET_LOCALE: UiLocale = "pt-BR";
export const DEFAULT_NATIVE_LOCALE: UiLocale = "en";
